import React, { useMemo } from 'react';
import WebsiteRenderer from './WebsiteRenderer';

// Helper function to convert the JSON object to CSS variables
const generateCssVariables = (config) => {
    const variables = {};
    variables['--primary'] = config.primary;
    variables['--secondary'] = config.secondary;
     variables['--topbar-bg-color'] = config.topBar.bgColor;
    variables['--topbar-text-color'] = config.topBar.textColor;
    variables['--header-bg-color'] = config.header.bgColor;
    variables['--header-link-color'] = config.header.linkColor;
     variables['--header-text-color'] = config.header.textColor;
    variables['--hero-overlay-color'] = config.hero.overlayColor;
     variables['--secondary-text-color'] = config.hero.subtitleColor;
     variables['--footer-bg-color'] = config.footer.bgColor;
    variables['--footer-text-color'] = config.footer.textColor;
    variables['--footer-link-color'] = config.footer.linkColor;
    // Add more variables as you expand your StyleBuilder
    return variables;
};

function TemplatePreview({ layout, styleConfig }) {
  // useMemo prevents the CSS variables from being recalculated on every render
  const cssVariables = useMemo(() => generateCssVariables(styleConfig), [styleConfig]);

  return (
    // The style attribute applies the CSS variables to this div and all its children
    <div style={cssVariables}> 
      <WebsiteRenderer layout={layout} />
    </div>
  );
}

export default TemplatePreview;